import HttpClient from "utils/HttpClient/HttpClient"
import {
    SUCCESSFUL_GET_SALEORDERS_SIGNEDCONTRACT,
    SUCCESSFUL_GET_SALEORDERS_PAYABLE,
    SUCCESSFUL_GET_SALEORDERS_WITH_PAYMENTS,
    SUCCESSFUL_GET_STATUS_SALEORDER_IN_PROGRESS
} from "./actionConst";

import { UPDATE_SALEORDER_AT_QUOTAS_TO_PAY } from "reducers/quotastopay/actionConst";
import { SHOW_ERROR_MESSAGE } from 'reducers/application/actionConst';

export const fetchSaleOrdersSignedContract = (firstItemLabel) => dispatch => {
    new HttpClient(true).get("b2c/saleorders/signed_contract")
        .then((response) => {
            console.log("Successful Fetch Products");
            dispatch({
                type: SUCCESSFUL_GET_SALEORDERS_SIGNEDCONTRACT,
                payload: saleOrdersToSelectModel(response.data, firstItemLabel)
            });
        })
        .catch((error) => {
            console.log("Failed Fetch Products");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: "Error al obtener los lotes"
            });
        })
}

export const fetchSaleOrdersPayable = (firstItemLabel) => dispatch => {
    new HttpClient(true).get("b2c/saleorders/payable")
        .then((response) => {
            console.log("Successful Fetch Products");
            const saleOrders = saleOrdersToSelectModel(response.data, firstItemLabel)
            dispatch({
                type: SUCCESSFUL_GET_SALEORDERS_PAYABLE,
                payload: saleOrders
            });
            dispatch({
                type: UPDATE_SALEORDER_AT_QUOTAS_TO_PAY,
                payload: saleOrders
            });
        })
        .catch((error) => {
            console.log("Failed Fetch Products");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: "Error al obtener los lotes"
            });
        })
}

export const fetchSaleOrdersWithPayments = (firstItemLabel) => dispatch => {
    new HttpClient(true).get("b2c/saleorders/with_payments")
        .then((response) => {
            console.log("Successful Fetch Products");
            dispatch({
                type: SUCCESSFUL_GET_SALEORDERS_WITH_PAYMENTS,
                payload: saleOrdersToSelectModel(response.data, firstItemLabel)
            });
        })
        .catch((error) => {
            console.log("Failed Fetch Products");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: "Error al obtener los lotes"
            });
        })
}


export const fetchStatusSaleOrderInProgress = (saleOrderId) => dispatch => {
    new HttpClient(true).get("b2c/payment/saleorder/inprogress",
        {
            params: {
                saleOrderId: saleOrderId
            }
        })
        .then((response) => {
            console.log("Successful Fetch Sale Order In Progress Status");
            dispatch({
                type: SUCCESSFUL_GET_STATUS_SALEORDER_IN_PROGRESS,
                payload: response.data
            });
        })
        .catch((error) => {
            console.log("Failed Fetch Sale Order In Progress Status");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: "Error de conexión"
            });
        })
}

export const fetchStatusSaleOrderInProgressPromise = (saleOrderId, resolve, reject) => dispatch => {
    new HttpClient(true).get("b2c/payment/saleorder/inprogress",
        {
            params: {
                saleOrderId: saleOrderId
            }
        })
        .then((response) => {
            console.log("Successful Fetch Sale Order In Progress Status");
            dispatch({
                type: SUCCESSFUL_GET_STATUS_SALEORDER_IN_PROGRESS,
                payload: response.data
            });
            if (response.data.value == true) {
                reject("Pago en Progreso");
            } else {
                resolve();
            }
        })
        .catch((error) => {
            console.log("Failed Fetch Sale Order In Progress Status");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: "Error de conexión"
            });
            reject();
        })
}

function saleOrderToSelectModel(saleorder) {
    return {
        value: saleorder.id,
        label: saleorder.name,
        status: saleorder.status,
        zeroInitialQuota: saleorder.zeroInitialQuota
    };
}

function saleOrdersToSelectModel(saleorders, firstItemLabel) {
    let saleOrdersSelectModel = [{
        value: 0,
        label: firstItemLabel
    }];

    for (const saleorder of saleorders) {
        saleOrdersSelectModel.push(saleOrderToSelectModel(saleorder));
    }
    return saleOrdersSelectModel;
}


// WEBPACK FOOTER //
// ./src/reducers/saleorders/saleordersActions.js